<template>
  <div class="flex flex-col justify-center items-center max-w-lg">
    <p class="text-primary font-bold text-2xl text-center">
      {{ title || $t("personList.cantFindTitle") }}
    </p>
    <p class="text-center">
      {{ text }}
    </p>
    <JoszakiButton
      :to="backUrl"
      class="mt-4"
      @click="$trackers.trackClick('BackToPersonList')"
    >
      &#60;&#60;&#60;
      {{ $t("personList.cantFindBackButtonText", { professionName }) }}
    </JoszakiButton>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: null,
    },
    text: {
      type: String,
      default: null,
    },
    professionName: {
      type: String,
      default: null,
    },
    backUrl: {
      type: String,
      default: null,
    },
  },
};
</script>
